import React from "react";
import { NumericFormat } from "react-number-format";
import classnames from "classnames";
import styled from "styled-components";
import { createDataTestId, AutomationTestIdFeature, AutomationTestIdElementType, AutomationPlacement } from "../../../utilities/automation"
import useLanguage from "../../../utilities/useLanguage";
import { getTranslation } from "../translations";


function fontSizeStyle(fontSize) {
    return `font-size: ${fontSize}px;`;
}

const YrPercentageContainer = styled.div<{ percentFontSize: number }>`
    font-size: 18px;

    @media(max-width:359px){
        font-size: 11px;
    }

    @media(min-width:769px) and (max-width:990px){
        ${props => fontSizeStyle(props.percentFontSize || 12)}
    }

    @media(min-width:1200px) and (max-width:1439px){
       font-size: 16px;
    }
`;

const CurrencyContainer = styled.div`
    @media(max-width:359px){
       padding: 0px;
    }
`;

export interface IYearAmountProps {
    monthlyPayment?: number,
    apr: number,
    initialRate: number,
    className?: string,
    children?: any,
    percentageClassName?: string,
    perMonthClassName?: string,
    percentFontSize?: number,
    location?: AutomationPlacement,
    paymentCount?: number
}

export default styled((props: IYearAmountProps) => {
    const { monthlyPayment = 0, apr, initialRate, className, children, percentageClassName, perMonthClassName, percentFontSize, location, paymentCount } = props;
    const { lang } = useLanguage();

    return (
        <div className={classnames(className, "justify-content-center", "align-items-center", "d-flex", "flex-column")}>
            <div className="row w-100">
                <CurrencyContainer className="col-12 text-center text-nowrap">
                    <NumericFormat
                        decimalScale={2}
                        fixedDecimalScale={true}
                        value={monthlyPayment}
                        thousandSeparator={true}
                        prefix={"$"}
                        displayType={"text"}
                        className={"text-serif p-0 m-0 amount col-8 text-right"}
                        data-test-id={createDataTestId({placement: location, feature: AutomationTestIdFeature.MRQT_CALCULATOR, element: AutomationTestIdElementType.TEXT, specifier: 'monthly_payment'})}
                        data-test-initial-rate={initialRate.toFixed(3)}
                        data-test-apr={apr.toFixed(3)}
                        data-test-payment-count={paymentCount}
                    />
                    <span className={`d-inline-block text-left text-serif per-month align-self-center ${perMonthClassName}`}>
                        <div>{getTranslation(lang).per}</div>
                        <div>{getTranslation(lang).month}*</div>
                    </span>
                </CurrencyContainer>
            </div>
            <YrPercentageContainer percentFontSize={percentFontSize} className={`row ${percentageClassName}`}>
                {initialRate.toFixed(3)}% ({apr.toFixed(3)}% {getTranslation(lang).apr})
            </YrPercentageContainer>
            {children}
        </div>
    );
})<{ amountLargeFontSize?: number }>`
    position: relative;

    .amount {
        font-family: "jubilat-variable",sans-serif;
        font-size: 2.333rem;

        @media(max-width: 1440px){
            ${props => fontSizeStyle(props.amountLargeFontSize || 34)}
        }
    }

    .per-month {
        font-family: "jubilat-variable",sans-serif;
        line-height: 1rem;
        font-size: 0.778rem;
    }

    & .info {
        right: .5rem !important;
        top: .2rem !important;
    }

    @media(max-width: 768px){
        .per-month{
             font-size: 0.722rem;
        }
     }

     @media(max-width:359px){
        .amount{
            font-size: 1.444rem;
        }

        .per-month{
            font-size: 0.611rem;
            line-height:.8rem !important;
        }
    }
`;